import { ContentCountryLanguage } from './contentCountryLanguage.model';
import { ContentFooterColumn } from './contentfootercolumn.model';
import { ContentFooterPopularTopic } from './contentfooterpopulartopic.model';
import { ContentFooterSocial } from './contentfootersocial.model';

export class ContentFooter {
  search: ContentSearch;
  populartopics: ContentFooterPopularTopic;
  footercolumns: ContentFooterColumn[];
  info: ContentFooterInfo;
  social: ContentFooterSocial;
  feedback: ContentFooterFeedback;
  countryLanguage: ContentCountryLanguage;
  additionalInfo?: Array<{ [key: string]: string }>;

  constructor(contentjson?: any) {
    if (contentjson) {
      this.search = new ContentSearch(contentjson['search']);
      this.populartopics = new ContentFooterPopularTopic(
        contentjson['populartopics']
      );
      this.footercolumns = this.fillColumn(contentjson['footercolumns']);
      this.info = new ContentFooterInfo(contentjson['info']);
      if (
        contentjson['socialIcons'] &&
        Object.keys(contentjson['socialIcons']).length > 0
      ) {
        this.social = new ContentFooterSocial(contentjson['socialIcons']);
      }
      if (
        contentjson['feedback'] &&
        Object.keys(contentjson['feedback']).length > 0
      ) {
        this.feedback = new ContentFooterFeedback(contentjson['feedback']);
      }
      if (
        contentjson['countrylanguage'] &&
        Object.keys(contentjson['countrylanguage']).length > 0
      ) {
        this.countryLanguage = new ContentCountryLanguage(
          contentjson['countrylanguage']
        );
      }
      if (
        contentjson['additionalInfo'] &&
        Object.keys(contentjson['additionalInfo']).length > 0
      ) {
        this.additionalInfo = contentjson['additionalInfo'];
      }
    } else {
      this.search = new ContentSearch();
      this.populartopics = new ContentFooterPopularTopic();
      this.footercolumns = this.fillColumn();
      this.info = new ContentFooterInfo();
      this.social = new ContentFooterSocial();
      this.feedback = new ContentFooterFeedback();
      this.countryLanguage = new ContentCountryLanguage();
    }
  }

  private fillColumn(contentjson?: any): ContentFooterColumn[] {
    let footerColumns: ContentFooterColumn[] = [];
    const columns = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        columns.set(counter, new ContentFooterColumn(counter, value));
        counter++;
      }
      footerColumns = Array.from(columns.values());
    }
    return footerColumns;
  }
}

export class ContentSearch {
  placeHolder: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['placeHolder']) {
        this.placeHolder = contentjson['placeHolder'];
      }
    } else {
      this.placeHolder = 'Search....';
    }
  }
}

export class ContentFooterInfo {
  disClaimer1: any;
  disClaimer2: any;
  copyRight: any;
  footerExtDesc: any;
  externalImgPath: any;
  footerTextImgPath: any;
  isShowFooterNote: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['disclaimer1']) {
        this.disClaimer1 = contentjson['disclaimer1'];
      } else {
        this.disClaimer1 = '';
      }
      if (contentjson['disclaimer2']) {
        this.disClaimer2 = contentjson['disclaimer2'];
      } else {
        this.disClaimer2 = '';
      }
      if (contentjson['copyright']) {
        this.copyRight = contentjson['copyright'];
      } else {
        this.copyRight = '';
      }
      if (contentjson['footerExtDesc']) {
        this.footerExtDesc = contentjson['footerExtDesc'];
      } else {
        this.footerExtDesc = '';
      }
      if (contentjson['externalImgPath']) {
        this.externalImgPath = contentjson['externalImgPath'];
      } else {
        this.externalImgPath = '';
      }
      if (contentjson['footerTextImgPath']) {
        this.footerTextImgPath = contentjson['footerTextImgPath'];
      } else {
        this.footerTextImgPath = '';
      }
      if (contentjson['isShowFooterNote']) {
        this.isShowFooterNote = contentjson['isShowFooterNote'];
      } else {
        this.isShowFooterNote = '';
      }
    }
  }
}

export class ContentFooterFeedback {
  fbUrl: any;
  fbTitle: any;
  fbIconPath: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['feedbackUrl']) {
        this.fbUrl = contentjson['feedbackUrl'];
      } else {
        this.fbUrl = '';
      }
      if (contentjson['feedbackTitle']) {
        this.fbTitle = contentjson['feedbackTitle'];
      } else {
        this.fbTitle = '';
      }
      if (contentjson['feedbackIconPath']) {
        this.fbIconPath = contentjson['feedbackIconPath'];
      } else {
        this.fbIconPath = '';
      }
    } else {
      this.fbUrl = '';
      this.fbTitle = '';
      this.fbIconPath = '';
    }
  }
}
